const S = "LastSearchService";
export {
  S as LAST_SEARCH_SERVICE
};
